// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/common/backendFrontend/dropdownCommentValue.ts

// A dropdown comment is the field value wrapped in one selection-mark, e.g.
// <selection-mark data-comment-id="X">value</selection-mark>. Uncommented dropdowns stay plain text.

export const buildDropdownCommentValue = (selectedValue: string, commentId: string): string => {
  const mark = document.createElement('selection-mark');
  mark.setAttribute('data-comment-id', commentId);
  mark.textContent = selectedValue; // textContent escapes, so the stored value is never live HTML
  return mark.outerHTML;
};

export const getDropdownCommentMark = (value: string): { commentId: string; text: string } | null => {
  const mark = new DOMParser().parseFromString(`<body>${value}</body>`, 'text/html').body.firstElementChild;
  const commentId = mark?.getAttribute('data-comment-id');
  if (mark?.tagName.toLowerCase() === 'selection-mark' && commentId) {
    return { commentId, text: mark.textContent ?? '' };
  }
  return null;
};
